import { debounce, isInViewportArea, loadLibrary } from "../../js/Util";
import { LIB_URL } from '../../js/App';

$('.js-facts-grid').each((i, gridDom) => {
    loadLibrary(LIB_URL.MASONRY, () => {
        const $grid = $(gridDom).masonry({
            itemSelector: ".js-facts-grid-item",
            percentPosition: true,
            gutter: 20,
            initLayout: false,
            stamp: '.js-facts-stamp'
        });

        let factsInited = false;

        const changeFactsGrid = () => {
            if (!factsInited && isInViewportArea(gridDom, 0.5)) {
                $grid.masonry();
                factsInited = true;
            }
        };
        const changeFactsGridDebounce = debounce(() => {
            changeFactsGrid();
        }, 100);

        window.addEventListener(
            "scroll",
            () => {
                changeFactsGridDebounce();
            },
            false
        );

        App.D.ready(() => {
            changeFactsGrid();

            if (App.mobile || App.W.width() <= 767) {
                gridDom.scrollLeft = 0;
            }
        });
    });
});
